import { useHistory } from 'react-router-dom';
import { useQuery } from 'react-query';

import { ChallengesService } from 'src/services';
import { usePracticePlanQueryParams, useScrollToTop } from 'src/hooks';
import { BackLink, Carousel, Header, Pagination, SessionCard } from 'src/components';
import PracticePlanSearchbox from 'src/features/PracticePlanSearchbox';
import { isNativePlatform } from '../../config';
import { ChallengeType } from 'src/models/Challenge';
import { PracticePlanQuery } from 'src/models/PracticePlan';

import {
  List,
  Item,
  SearchboxWrapper,
} from './styles';
import { arrayOfNumbers } from 'src/utils/array';
import { BackNavigationInfo } from 'src/models/BackNavigationInfo';

const defaultTitle = 'Plany praktyki';
const defaultUnderline = '';
const itemsPerPage = 12;

const PracticePlanLibrary: React.FC = () => {
  const history = useHistory();
  const query = usePracticePlanQueryParams();

  const backInfo: BackNavigationInfo = {
    link: `${history.location.pathname}${history.location.search}`,
    linkLabel: 'Plany praktyki',
  };

  const { data, isFetching } = useQuery(
    ['PracticePlanLibrary', ChallengeType.PracticePlan, query],
    () => ChallengesService.getMany({
      ...query,
      limit: itemsPerPage,
      page: query.page ?? 1,
      challengeType: ChallengeType.PracticePlan,
    }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    },
  );
  useScrollToTop([query.page]);

  const handlePageClick = (selectedPage: number) => {
    const newPage = selectedPage + 1;
    const params = PracticePlanQuery.serializeToUrlParams({
      ...query,
      page: newPage,
    });
    history.push({ search: params });
  };

  const practicePlans = data?.data ?? [];
  const page = data?.page ?? 0;
  const pageCount = data?.pageCount ?? 0;

  const title = query.title || defaultTitle;
  const underline = query.underline || (query.title ? '' : defaultUnderline);

  const actualItemCount = isFetching ? null : practicePlans.length;
  const displayItemCount = actualItemCount ?? itemsPerPage;

  return (
    <>
      <BackLink
        label='Strona główna'
        to="/home"
      />
      {
        !isNativePlatform &&
          <Carousel page="practicePlans" />
      }
      <Header
        title={title}
        underline={underline}
        as="h1"
      />
      <SearchboxWrapper>
        <PracticePlanSearchbox
          searchPending={isFetching}
          results={data?.total}
        />
      </SearchboxWrapper>
      <List multiplePages={pageCount > 1}>
        {arrayOfNumbers(displayItemCount).map(index => (
          <Item key={index}>
            <SessionCard
              mode="vertical"
              session={practicePlans[index]}
              order={index}
              pathBase="practice-plans"
              backNavigationInfo={backInfo}
            />
          </Item>
        ))}
      </List>
      <Pagination
        page={page}
        pageCount={pageCount}
        onPageChange={handlePageClick}
      />
    </>
  );
};

export default PracticePlanLibrary;
